<template>
  <div>
    <div
      class="jRules jFlow">
      <jFloatingPrompt ref="rulesFloating">

        <h2 class="inline--block">
          {{ rules.name }}
        </h2>

        <!-- button UPDATE or DELETE -->
        <div class="wrap-button-flow">
          <b-button
            class="btn border white m__r--10 btn-secondary"
            @click="updateRule">
            EDIT
          </b-button>
          <b-button
            class="btn red btn-secondary"
            @click="rulesDeleted">
            DELETE
          </b-button>
          <i
            class="fa fa-times"
            @click="hideRulesFloating"/>
        </div>

        <div class="overflow-scroll">
          <div class="inline--block">
            <div class="flow-new__bullet-top sincronize-top">
              <i class="fa fa-square"/>
            </div>
          </div>
          <div
            v-for="(rule, index) in rules.flows"
            :key="index"
            class="inline--block">
            <div
              v-if="index === 0"
              class="line-horizontal"/>
            <div
              v-if="index > 0"
              class="line-horizontal next-line"/>
            <div class="inline--block">
              <div
                :class="{'darken-click' : current_click_rules === index}"
                class="flow-table flow-arrow light-blue-flow"
                @click="getDetailFlow(index)">
                {{ rule.name }}
              </div>
            </div>
          </div>
        </div>

        <h2
          v-if="detail_flow"
          class="inline--block">
          {{ detail_flow.name }}
        </h2>

        <!-- flow detail -->
        <div
          v-if="detail_flow"
          class="overflow-scroll">
          <div class="inline--block bullet">
            <div class="flow-new__bullet-top">
              <i class="fa fa-square"/>
            </div>
          </div>
          <div
            v-for="(approver, index) in detail_flow.members"
            :key="index"
            class="approver-order inline--block">

            <div class="inline--block line-wrap">
              <div class="line-horizontal"/>
            </div>

            <div class="inline--block box-flow">
              <div class="header-flow">
                <!-- <div class="header-actions">
                  <i
                    class="fa fa-edit"/>
                  <i
                    class="fa fa-times"/>
                </div> -->
                Approver {{ approver.order }}
              </div>
              <div class="content-flow">
                {{ approver.organigram.name }} <br>
                {{ approver.organigram_member_name ? approver.organigram_member_name : "" }}
              </div>
            </div>
          </div>
        </div>
      </jFloatingPrompt>
    </div>
  </div>
</template>

<script>
import jFloatingPrompt from '@/components/new-floating-templete/jFloatingPrompt';
import { mapActions } from 'vuex';

export default {
  components: { jFloatingPrompt },
  props: {
    rules: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      current_click_rules: null,
    };
  },
  computed: {
    detail_flow() {
      return this.rules.flows[this.current_click_rules];
    },
  },
  methods: {
    ...mapActions('jStoreRules', ['detailRules']),
    getDetailFlow(index) {
      this.current_click_rules = index;
    },
    rulesDeleted() {
      const text = `You want to delete "${this.rules.name}"`;

      this.$swal({
        title: 'Are you sure?',
        text,
        type: 'question',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.$emit('deleteRules');
        }
      });
    },
    hideRulesFloating() {
      this.$refs.rulesFloating.hide();
      this.$emit('hideFloatingPrompt');
    },
    updateRule() {
      const ids = this.rules.id;
      this.$router.replace(`/rules/update/${ids}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-flow {
  color: #42a5ce;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 16px;
  .wrap-button-flow {
    position: relative;
    .btn {
      margin-left: 20px;
    }
  }
  .close-modal-flow {
    color: #42a5ce;
    cursor: pointer;
    font-size: 25px;
    position: absolute;
    right: 20px;
    top: 16px;
  }
  .title-flow {
    color: black;
    margin-bottom: 20px;
  }
  .modal-body {
    padding-bottom: 0px;
  }
}
.jFlow.flow-flex-center .wrap-button-flow .btn {
  margin-left: 20px;
}
h3 {
  text-align: center;
}
.mod-form .modal-body {
  padding-bottom: 0px;
}

// floating prompt in rules
.jRules {
  .sincronize-top {
    top: 12px;
  }
  .flow-arrow {
    cursor: pointer;
    &.darken-click {
      background: darken(#b3e8f8, 10%);
      &:after {
        background: darken(#b3e8f8, 10%);
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/flow-rule/rules/jRulesFloatingPrompt.vue